import { Cookies } from 'react-cookie';
import ReactGA from 'react-ga4';

export default class GoogleAnalyticsHandler {
  constructor() {
    this.gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID;
    this.cookie = new Cookies();
    this.domain = `.${window.location.hostname}`;
  }

  initialize() {
    if (this.isAllowCookies()) {
      ReactGA.initialize(this.gaTrackingId, {
        gtagOptions: {
          cookie_domain: this.domain,
        },
      });
    }
  }

  cookiesList() {
    return [
      '_ga',
      '_gid',
      '_ga_SPLZE674HK',
      '_gat_gatag_'.concat(this.gaTrackingId).replace('-', '_'),
      '__Secure-1PAPISID',
      '__Secure-1PSID',
      '__Secure-1PSIDCC',
      '__Secure-1PSIDTS',
      '__Secure-3PAPISID',
      '__Secure-3PSID',
      '__Secure-3PSIDCC',
      '__Secure-3PSIDTS',
      '__Secure-ENID',
      'AEC',
      'APISID',
      'HSID',
      'NID',
      'SAPISID',
      'SID',
      'SIDCC',
      'SSID',
    ];
  }

  event(category, action) {
    if (this.isAllowCookies()) {
      this.initialize();

      ReactGA.event({
        category,
        action,
      });
    }
  }

  pageview(page) {
    if (this.isAllowCookies()) {
      this.initialize();

      ReactGA.send({
        hitType: 'pageview',
        page,
        title: page,
      });
    }
  }

  isAllowCookies() {
    return this.cookie.get('allowCookies') === true;
  }
}
